if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");
        if (this.formInput) this.formInput.disabled = false;
        this.form?.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart = document.querySelector("cart-drawer");
        this.cartType = this.cart?.dataset.cartType;

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        if (document.querySelector("cart-drawer"))
          this.submitButton?.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton = this.disableLoadingInButton.bind(this);
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );
        if (this.body.classList.contains("quick-buy-page-overlay"))
          this.body.classList.remove("quick-buy-page-overlay");
        if (
          complementaryOverlayPage.classList.contains(
            "wt__quick-buy--page-overlay--open",
          )
        )
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
      }

      showNotification(productData = {}) {
        console.log("Intentando mostrar notificación", productData);
        const notification = document.querySelector(".add-to-cart-notification");
        if (!notification) {
          console.error("No se encontró el elemento .add-to-cart-notification");
          return;
        }

        const image = notification.querySelector(".notification-image");
        const title = notification.querySelector(".notification-title");
        const price = notification.querySelector(".notification-price");

        if (productData.image && image) {
          image.src = productData.image;
          image.alt = productData.title || "Producto";
        } else {
          image.src = ''; // Imagen por defecto si no hay
          image.alt = 'Producto';
        }
        if (productData.title && title) {
          title.textContent = productData.title;
        } else {
          title.textContent = 'Producto añadido';
        }
        if (productData.price && price) {
          price.textContent = productData.price;
        } else {
          price.textContent = '';
        }

        notification.style.display = "block";
        setTimeout(() => {
          notification.style.display = "none";
          console.log("Notificación ocultada");
        }, 3000);
      }

      updateCartCount() {
        console.log("Actualizando contador del carrito");
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            const cartCountElement = document.querySelector('.cart-count');
            if (cartCountElement) {
              cartCountElement.textContent = cart.item_count;
              cartCountElement.style.display = cart.item_count > 0 ? 'block' : 'none';
              console.log("Contador del carrito actualizado:", cart.item_count);
            } else {
              console.error("No se encontró el elemento .cart-count");
            }
          })
          .catch((e) => console.error("Error al actualizar el carrito:", e));
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.cart?.setActiveElement(document.activeElement);

        const loader = this.querySelector(".loading-overlay__spinner");

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        if (loader) loader.classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        formData.append(
          "sections",
          this.cart?.getSectionsToRender().map((section) => section.id) || [],
        );
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        // Obtener datos del producto desde el DOM como respaldo
        const productImage = document.querySelector('.product__media img')?.src || '';
        const productTitle = document.querySelector('.product__title h1')?.textContent || 'Producto';
        const productPrice = document.querySelector('.price__regular .price-item')?.textContent || '';

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.log("Error en la respuesta:", response);
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.error = true;

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) {
                this.showNotification({ title: "Error al añadir el producto", price: "", image: "" });
                return;
              }
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              return;
            }

            console.log("Producto añadido correctamente:", response);
            this.error = false;
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });

            this.updateCartCount();

            const productData = {
              image: response.image || productImage,
              title: response.title || productTitle,
              price: response.price ? (response.price / 100).toFixed(2) + '€' : productPrice,
            };
            this.showNotification(productData);

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.showNotification(productData);
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true },
              );
              if (this.cartType === "drawer") quickAddModal.hide(true);
            } else {
              const isClosedCart = !document.body.classList.contains(
                "page-overlay-cart-on",
              );
              this.redirectAfterSubmit(response, isClosedCart);
            }
          })
          .catch((e) => {
            console.error("Error en la solicitud:", e);
            this.error = true;
            this.handleErrorMessage("Error al añadir el producto al carrito");
            this.showNotification({ title: "Error al añadir el producto", price: "", image: "" });
          })
          .finally(() => {
            console.log("Finalizando solicitud");
            this.disableLoadingInButton();
            if (this.cartType === "page") {
              if (this.error) return;
            }
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");

            this.quick_add_container = document.querySelector(
              ".wt__quick-buy__container",
            );
            this.quick_add_overlay = document.querySelector(
              ".wt__quick-buy--page-overlay",
            );
            this.quick_add_product =
              this.quick_add_container?.querySelector(".wt-product");
            this.loader = this.quick_add_container?.querySelector(
              ".wt__quick-buy-loader",
            );

            if (this.quick_add_container && !this.quick_add_container.classList.contains("hidden")) {
              this.quick_add_product?.remove();
              this.quick_add_container.classList.remove(
                "wt__quick-buy__container--open",
              );
              this.quick_add_overlay?.classList.remove(
                "wt__quick-buy--page-overlay--open",
              );
              document.body.classList.remove("quick-buy-page-overlay");
              this.loader?.classList.remove("hidden");
            }
          });
      }

      disableLoadingInButton() {
        console.log("Restableciendo botón");
        this.submitButton.classList.remove("loading");
        this.querySelector(".loading-overlay__spinner")?.classList.add("hidden");
      }

      redirectAfterSubmit(response, isClosedCart = true) {
        console.log("Ejecutando redirectAfterSubmit", { cartType: this.cartType, isClosedCart });
        const body = document.body;
        const isCartPage = body.classList.contains("template-cart");

        if (this.cartType === "drawer" && isCartPage) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );
          overlay?.classList.remove("wt__quick-buy--page-overlay--open");
          body.classList.remove("quick-buy-page-overlay");
        } else if (this.cartType === "drawer") {
          this.cart.renderContents(response, isClosedCart);
          return;
        }
        // No redirigir
        console.log("No se redirige al carrito");
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    },
  );
}